var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFollowUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#1D4469",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2831 11.1072C11.6017 11.1072 12.6707 10.0386 12.6707 8.7203C12.6707 7.40204 11.6017 6.33337 10.2831 6.33337C8.96448 6.33337 7.89551 7.40204 7.89551 8.7203C7.89551 10.0386 8.96448 11.1072 10.2831 11.1072Z",
    fill: "#1D4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9017 15.2353C10.4507 14.751 10.1746 14.1017 10.1746 13.3883C10.1746 12.6579 10.4641 11.9943 10.9347 11.5065C10.722 11.49 10.5045 11.4813 10.2831 11.4813C8.841 11.4813 7.56429 11.842 6.7716 12.3823C6.16689 12.7946 5.8335 13.3184 5.8335 13.8683V14.4975C5.8335 14.6933 5.9112 14.8812 6.04968 15.0192C6.18816 15.1576 6.3757 15.2353 6.57148 15.2353H10.9017Z",
    fill: "#1D4469"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8878 11.1098C11.6297 11.1098 10.6087 12.1306 10.6087 13.3883C10.6087 14.646 11.6297 15.6667 12.8878 15.6667C14.1458 15.6667 15.1668 14.646 15.1668 13.3883C15.1668 12.1306 14.1458 11.1098 12.8878 11.1098ZM11.839 13.7676L12.4901 14.2016C12.619 14.2875 12.7914 14.2706 12.9008 14.1608L13.9861 13.0758C14.1132 12.9491 14.1132 12.7425 13.9861 12.6158C13.8593 12.4886 13.6527 12.4886 13.5259 12.6158L12.629 13.512L12.2001 13.226C12.0508 13.1261 11.8485 13.1669 11.7487 13.3162C11.6488 13.4655 11.6896 13.6678 11.839 13.7676Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUpIcon);
export default __webpack_public_path__ + "static/media/FollowUpIcon.b090981c20a1a1f6194e1bc2c93fbefa.svg";
export { ForwardRef as ReactComponent };